export interface DotPosition {
  x: number;
  y: number;
}

export const DECAY_FACTOR = 0.001;

export const calculateY = (
  x: number,
  startX: number,
  startY: number,
  endY: number,
  decayFactor: number
): number => {
  const adjustedStartY = Math.max(startY, endY); // Adjust the startY to be at least the endY
  const adjustedEndY = Math.min(startY, endY); // Adjust the endY to be at most the startY
  return (
    adjustedStartY -
    Math.exp(-decayFactor * (x - startX)) * (adjustedStartY - adjustedEndY)
  );
};

export const timestampToPosition = (
  timestamp: number,
  start: number,
  finish: number,
  startX: number,
  startY: number,
  endX: number,
  height: number
): DotPosition => {
  const normalizedTime: number = Math.min(
    Math.max((timestamp - start) / (finish - start), 0),
    1
  );

  const x: number = normalizedTime * (endX - startX) + startX;

  const y: number = calculateY(
    x,
    startX,
    startY,
    height,
    Math.log(height / (height * DECAY_FACTOR)) / (endX - startX)
  );
  return { x, y };
};
